import { Component, forwardRef, Input, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ControlValueAccessorDirective } from '../../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ]
})
export class CheckboxComponent extends ControlValueAccessorDirective {
  @Input() title:string = "";
  @Output() valueChanged:EventEmitter<boolean> = new EventEmitter();
  constructor(){
    super();
  }

  public valueChangedHandler(value: MatCheckboxChange){
    this.change();
    this.valueChanged.emit(value.checked);
  }
  
}
